require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./champions-league-la-doctrina-monroe-de-los-poderosos-en-europa.json") })
        }
      }, "path---champions-league-la-doctrina-monroe-de-los-poderosos-en-europa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---champions-league-la-doctrina-monroe-de-los-poderosos-en-europa!./.cache/json/champions-league-la-doctrina-monroe-de-los-poderosos-en-europa.json
// module id = 444
// module chunks = 231608221292675